import { createStore, createEffect, createEvent, combine } from 'effector';
import { $accountByIdStore } from '../accounts';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import {
  AlertsApi,
  type AddMinimalBalanceRequest,
  type AlertSubscriptionResponse,
  type Recipient,
  type UpdateMinimalBalanceRequest,
} from '@shared/api';

const addMinimalBalanceEffect = createEffect((request: AddMinimalBalanceRequest) => AlertsApi.addMinimalBalance(request));
const updateMinimalBalanceEffect = createEffect((request: UpdateMinimalBalanceRequest) => AlertsApi.updateMinimalBalance(request));

const getRecipientEvent = createEvent<Recipient[]>();
const addRecipientEvent = createEvent<Recipient>();
const removeRecipientEvent = createEvent<string>();

updateMinimalBalanceEffect.done.watch((result) => {
  if (result.result?.data?.accountId != null) $accountByIdStore.events.getAccount({ id: result.result.data.accountId });
});
addMinimalBalanceEffect.done.watch((result) => {
  if (result.result?.data?.accountId != null) $accountByIdStore.events.getAccount({ id: result.result.data.accountId });
});

const clearEvent = createEvent();

const $dataStore = createStore<AlertSubscriptionResponse | null>(null)
  .on(addMinimalBalanceEffect.done, (_, data) => data.result.data || null)
  .reset(clearEvent);

const $recipientStore = createStore<Recipient[]>([])
  .on(addRecipientEvent, (state, recipient) => [...state, recipient])
  .on(removeRecipientEvent, (state, email) => state.filter((recipient) => recipient.email !== email))
  .on(getRecipientEvent, (_, newRecipient) => newRecipient)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(addMinimalBalanceEffect.pending, (_, data) => data)
  .on(addMinimalBalanceEffect.fail, () => false)
  .on(addMinimalBalanceEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(addMinimalBalanceEffect, () => null)
  .on(
    addMinimalBalanceEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while adding Subscription Minimal Balance. Please try again.').message,
  )
  .on(addMinimalBalanceEffect.done, () => null)
  .on(updateMinimalBalanceEffect, () => null)
  .on(
    updateMinimalBalanceEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Subscription Minimal Balance. Please try again.').message,
  )
  .on(updateMinimalBalanceEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $minimalBalanceStore = {
  events: {
    addMinimalBalance: addMinimalBalanceEffect,
    updateMinimalBalance: updateMinimalBalanceEffect,
    get: getRecipientEvent,
    add: addRecipientEvent,
    remove: removeRecipientEvent,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    recipient: $recipientStore,
    error: $errorStore,
  }),
};
